import { compact } from 'lodash';
import { routes } from 'commons';

export function removeSpecialCharacters(text: string): string {
  return text.replace(/[-.]/g, '');
}

export function curtailStringWithEllipsis(
  string: string,
  maxStringSize: number
) {
  return string.length <= maxStringSize
    ? string
    : string.substring(0, maxStringSize) + '...';
}

export function getRoutePathsAndName(route: string): {
  path: string;
  name: string;
}[] {
  const paths = route.replace(/\//, '').split('/');

  const filteredPaths = paths.filter(Boolean);

  const pages = filteredPaths.map((p, index) => {
    let currentPath = paths.slice(0, index + 1).join('/');

    return currentPath;
  });

  const pathsAndNames = pages.map((path) => {
    return Object.values(routes).find((value) =>
      value.path.includes(`/${path}`)
    );
  });

  const filteredPathsAndNames = compact(pathsAndNames);

  return filteredPathsAndNames;
}

export function formatNumberEnsuringTwoDigits(number: number): string {
  return number.toLocaleString('pt-BR', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });
}
